export default __webpack_public_path__ + "static/media/Background.28148915.png";